export const SEND_FILES = 'SEND_FILES';
export const OPEN_CONNECTION = 'OPEN_CONNECTION';
export const CLOSE_CONNECTION = 'CLOSE_CONNECTION';
export const SET_AVAILABILITY = 'SET_AVAILABILITY';
export const SEND_DASHBOARD = 'SEND_DASHBOARD';
export const STOP_DASHBOARD = 'STOP_DASHBOARD';
export const CLOSE_DASHBOARD = 'CLOSE_DASHBOARD';

export const SEND_PATIENT = 'SEND_PATIENT';

